import { OmniToolbar } from "./component/omni-toolbar/omni-toolbar.js";
import { OmniAppLayout } from "./component/omni-app-layout/omni-app-layout.js";
import { OmniStyle } from "./component/omni-style/omni-style.js";
import { OmniIcon } from "./component/omni-icon/omni-icon.js";
import { OmniCardGrid } from "./component/omni-card-grid/omni-card-grid.js";
import { OmniContextProvider } from "./component/omni-context-provider/omni-context-provider.js";
import { OmniImgUpload } from "./component/omni-img-upload/omni-img-upload.js";
import { OmniImageInput } from "./component/omni-img-input/omni-img-input.js";
import { OmniSearch } from "./component/omni-search/omni-search.js";
import { OmniLoadingIndicator } from "./component/omni-loading-indicator/omni-loading-indicator.js";
import { OmniBadge } from "./component/omni-badge/omni-badge.js";
import { OmniDialog } from "./component/omni-dialog/omni-dialog.js";
import { OmniSwitch } from "./component/omni-switch/omni-switch.js";
import { OmniTable } from "./component/omni-table/omni-table.js";
import { OmniTile } from "./component/omni-tile/omni-tile.js";
import { OmniTheme } from "./component/omni-theme/omni-theme.js";
import { OmniCard } from "./component/omni-card/omni-card.js";
import { OmniTooltip } from "./component/omni-tooltip/omni-tooltip.js";
import { OmniChip } from "./component/omni-chip/omni-chip.js";
console.warn(
  "Component name update: We are aligning our component names with their custom element representation to make them shorter and more intuitive. We are removing the suffix 'Element' from all components except 'OmniElement', so 'OmniIconElement' becomes 'OmniIcon', etc. These 'Element' appended component names are deprecated and will be removed in the next major version.\n\nUse the `update-imports` code mod to make all of these rewrites at once `npx omni-ui update-imports --include=path` where path equals your directory path to project components."
);
export {
  OmniAppLayout as OmniAppLayoutElement,
  OmniBadge as OmniBadgeElement,
  OmniCard as OmniCardElement,
  OmniCardGrid as OmniCardGridElement,
  OmniChip as OmniChipElement,
  OmniContextProvider as OmniContextProviderElement,
  OmniDialog as OmniDialogElement,
  OmniIcon as OmniIconElement,
  OmniImageInput as OmniImageInputElement,
  OmniImgUpload as OmniImgUploadElement,
  OmniLoadingIndicator as OmniLoadingIndicatorElement,
  OmniSearch as OmniSearchElement,
  OmniStyle as OmniStyleElement,
  OmniSwitch as OmniSwitchElement,
  OmniTable as OmniTableElement,
  OmniTheme as OmniThemeElement,
  OmniTile as OmniTileElement,
  OmniToolbar as OmniToolbarElement,
  OmniTooltip as OmniTooltipElement
};
//# sourceMappingURL=exports-deprecated-names-remap.js.map
